var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.002 10.996c0-1.495.002-2.989-.004-4.482a.54.54 0 01.172-.415C2.15 4.125 4.126 2.149 6.1.169A.539.539 0 016.516 0c2.988.004 5.977.005 8.964 0 .18 0 .307.058.432.183a2745.3 2745.3 0 005.914 5.914c.12.12.172.243.172.414-.004 2.996-.004 5.991 0 8.986a.516.516 0 01-.162.397c-1.984 1.98-3.965 3.96-5.945 5.944a.513.513 0 01-.398.161c-2.995-.003-5.99-.004-8.986 0a.54.54 0 01-.413-.175c-1.969-1.975-3.94-3.946-5.915-5.914a.556.556 0 01-.181-.433c.006-1.493.004-2.987.004-4.481zM11 9.643c-2.201 0-4.403.002-6.604-.003-.182-.001-.25.044-.248.239.01.75.01 1.5 0 2.25-.001.181.06.231.235.231 4.41-.004 8.82-.004 13.229.001.196 0 .24-.069.238-.25-.009-.729-.003-1.458-.003-2.187 0-.28-.001-.28-.286-.28h-6.56z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/minus.05c898a0.svg";
export { ForwardRef as ReactComponent };